(ns manage.ad-variant-preview.share
  (:require ["@hookform/devtools" :as form-devtools]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["material-ui-popup-state/hooks" :as muips]
            ["src/svg/chevron/chevron-down.svg$default" :as ChevronDown]
            ["src/svg/location/globe-europe-africa.svg$default" :as GlobeEuropeAfrica]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.queries :refer [invalidate-queries use-mutation use-query]]
            [common.util :refer [spread-props]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.form-field :refer [form-field]]
            [manage.ad-variant.data :as variant-data]
            [manage.ad-variant.queries :as q]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn links-have-been-revoked? [status-resp]
  (boolean (get status-resp :share-link/status false)))

(defui permission-selector [_]
  (let [url-context (use-subscribe [:url-context])
        query (q/check-for-revoked-links-query url-context)
        {:keys [isLoading data]} (use-query query)

        popup-state (muips/usePopupState #js {:variant "menu"})

        {:keys [mutate]} (use-mutation (q/revoke-share-link-mutation url-context))
        update-link-statuses-for-entities (fn [new-link-status]
                                            (mutate new-link-status
                                                    #js {:onSuccess (fn [_resp]
                                                                      (invalidate-queries {:queryKey (.-queryKey query)}))
                                                         :onError (fn [_error]
                                                                    (rf/dispatch [:toaster-bus/add
                                                                                  {:id ::new-share-link-permission
                                                                                   :type :error
                                                                                   :message "There was an error modifying exisiting share links"}]))
                                                         :onSettled (.-close popup-state)}))]

    ($ :<>
       ($ Button
          (spread-props {:disabled isLoading
                         :endIcon ($ ChevronDown)}
                        (muips/bindTrigger popup-state))
          (if (links-have-been-revoked? data)
            "Cannot access"
            "Can view"))
       ($ Menu
          (spread-props {:anchorOrigin #js {:vertical "bottom"
                                            :horizontal "right"}
                         :transformOrigin #js {:vertical "top"
                                               :horizontal "right"}}
                        (muips/bindMenu popup-state))
          ($ MenuItem
             {:selected (not (links-have-been-revoked? data))
              :onClick (fn [_]
                         (update-link-statuses-for-entities :restore))}
             "Can view")
          ($ MenuItem
             {:selected (links-have-been-revoked? data)
              :onClick (fn [_]
                         (update-link-statuses-for-entities :revoke))}
             "Cannot access")))))

(defn copy-share-link [share-link]
  (-> (js/Promise. (fn [resolve reject]
                     (if (some? share-link)
                       (-> (.-clipboard js/navigator)
                           (.writeText share-link)
                           (.then (fn []
                                    (resolve nil)))
                           (.catch (fn [e]
                                     (reject e))))
                       (reject nil))))))

(defui ^:memo share-dialog [{:keys [open ad-variants visible-variants product-overrides]}]
  ;; TODO: Using this is inconvenient if we lose hook state on shadow-cljs reloads.
  (let [handle-close (fn [_e] (rfe/set-query #(dissoc % :share)))

        {:keys [advertiser-id adset-id]} (use-subscribe [:url-context])

        selection-option-selected "selected"
        selection-option-all "all"

        ;; All variants
        ad-variant-uuids (uix/use-memo (fn []
                                         (mapv :uuid ad-variants))
                                       [ad-variants])

        ;; Selected variants
        ad-variant-selection-uuids (variant-data/variants->selection visible-variants)

        ;; Used to decide if the "Copy link" button should be disabled
        {revoked-links-data :data} (use-query (q/check-for-revoked-links-query {:advertiser-id advertiser-id
                                                                                :adset-id adset-id}))

        {:keys [control handleSubmit reset]}
        (form/use-form #js {;; by default only onSubmit triggers validation
                            :mode "all"
                            ;; For controlled inputs to be reset, defaultValues has to have
                            ;; a value for them.
                            :defaultValues #js {:selection selection-option-all
                                                #_#_:email #js ["foo@example.com"]
                                                #_#_:permissions #js []
                                                #_#_:message ""}
                            :values #js {:selection selection-option-all}})

        [include_modified set-include-modified] (uix/use-state false)

        product-overrides-ids-only (update-vals product-overrides #(->> % (map :id) vec))

        share-constraints (merge {selection-option-all []
                                  selection-option-selected ad-variant-selection-uuids}
                                 (when include_modified {"products" product-overrides-ids-only}))

        {:keys [mutate]} (use-mutation (q/create-share-link-mutation {:advertiser-id advertiser-id
                                                                      :adset-id adset-id
                                                                      :share-constraints share-constraints}))
        new-share-link (fn [new-data]
                         (mutate (->clj new-data)
                                 #js {:onSuccess (fn [resp]
                                                   (-> (copy-share-link (:share-link/link (->clj resp)))
                                                       (.then (fn []
                                                                (rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                                                :type :success
                                                                                                :message "Link copied to clipboard"}])
                                                                (reset)
                                                                (handle-close nil)))
                                                       (.catch (fn []
                                                                 (rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                                                 :type :error
                                                                                                 :message "Could not copy link to clipboard"}])))))}))]

    ($ Dialog
       {:open (boolean open)
        :onClose handle-close
        :fullWidth true
        :maxWidth "sm"
        :PaperProps #js {:component "form"
                         :onSubmit (handleSubmit (fn [^js form-data _e]
                                                   (new-share-link form-data)))}}
       ($ DialogTitle
          {:sx #js {:display "flex"
                    :alignItems "center"
                    :justifyContent "space-between"}}
          "Share"

          ($ IconButton
             {:on-click handle-close
              :data-testid "closeButton"}
             ($ Icon
                {:sx #js {:color "grey.40"}}
                "close")))
       ($ DialogContent
          {:sx #js {:display "flex"
                    :flexDirection "column"
                    :gap 2}}
          ($ form-field
             {:label "Ad variants"}
             ($ form/select-field
                {:control control
                 :name "selection"
                 :rules #js {:required true}
                 :field-props (fn [_props]
                                {:options [{:id selection-option-selected
                                            :label (str "Selected variants (" (count ad-variant-selection-uuids) ")")
                                            :disabled (empty? ad-variant-selection-uuids)}
                                           {:id selection-option-all
                                            :label (str "All variants (" (count ad-variant-uuids) ")")
                                            :disabled (empty? ad-variant-uuids)}]})}))

          ($ Stack {:gap 2}
             (when (not-empty product-overrides)
               ($ checkbox
                  {:id :relative-datetime
                   :value include_modified
                   :on-change #(set-include-modified (not include_modified))
                   :label "Include modified products"}))
             ($ Divider)
             ($ Stack {:direction "row"
                       :alignItems "flex-start"
                       :gap 2}
                ($ SvgIcon
                   {:component GlobeEuropeAfrica
                    :sx #js {:color "grey.10"
                             :backgroundColor "grey.80"
                             :borderRadius "32px"
                             :width 32
                             :height 32}})
                ($ Stack {:gap 2}
                   ($ Typography {:variant "h4"} "Anyone with the link")
                   ($ Typography {:sx #js {:color "grey.30"}}
                      "This will enable anyone with the link to access this page."))
                ($ permission-selector))
             ($ Divider))

          ;; FIXME: Right now this is also enabled for release builds
          ($ form-devtools/DevTool {:control control}))

       ($ DialogActions
          ($ Button
             {:onClick handle-close}
             "Cancel")
          ($ Button
             {:type "submit"
              :disabled (links-have-been-revoked? revoked-links-data)
              :variant "contained"}
             "Copy link")))))
